import React, { useState } from 'react';
import './AEHS.css'; // Import the CSS file
import { Container, Grid, Card, CardMedia, CardContent, Typography, Button, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Calender from '../cgc/CoverPageComponents/Calender';
import TikTokIcon from './icons/TikTokIcon';
import facebookIcon from '../../../../src/assets/images/fb icon.png';
import facebookWhiteIcon from '../../../../src/assets/images/fb icon white.png';
import InstaIcon from './icons/InstaIcon.js';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import YouTubeIcon from '@mui/icons-material/YouTube';
import AEHSAnnouncement from './AEHSAnnouncement.js';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import { translations } from './dataContent.js';
import biscuits from '../../../../src/assets/images/biscuits.png';
import fbimg from '../../../../src/assets/images/social media/fb.jpg';
import instaimg from '../../../../src/assets/images/social media/ig.jpg';
import gallery1 from '../../../../src/assets/images/photo gallery/gallery (1).jpg';
import gallery2 from '../../../../src/assets/images/photo gallery/gallery (2).jpg';
import gallery3 from '../../../../src/assets/images/photo gallery/gallery (3).jpg';
import gallery4 from '../../../../src/assets/images/photo gallery/gallery (4).jpg';
import gallery5 from '../../../../src/assets/images/photo gallery/gallery (5).jpg';
import gallery6 from '../../../../src/assets/images/photo gallery/gallery (6).jpg';
import gallery7 from '../../../../src/assets/images/photo gallery/gallery (7).jpg';
import gallery8 from '../../../../src/assets/images/photo gallery/gallery (8).jpg';
import gallery9 from '../../../../src/assets/images/photo gallery/gallery (9).jpeg';
import learnMore_pdf from '../../../../src/assets/images/docs/COURSE_CONTENTS.pdf';
import hero from '../../../../src/assets/images/aehsHero.png';
import AehsCourseModal from './aehsCourseModal.js';
import {
  nvq_3_international_cookery,
  nvq_4_international_cookery,
  nvq_3_bakery,
  nvq_4_bakery,
} from './dataContent.js';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  ...theme.applyStyles('dark', {
    backgroundColor: '#1A2027',
  }),
}));

const HomePage = () => {

  const [selectedLanguage, setSelectedLanguage] = useState('en');
  const t = translations[selectedLanguage] || translations.en;
  const [courseData, setCourseData] = useState({});
  const [courseTitle, setCourseTitle] = useState({});

  const handleLanguageChange = (event) => {
    setSelectedLanguage(event.target.value);
  };

  const [open1, setOpen1] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [open3, setOpen3] = useState(false);
  const [open4, setOpen4] = useState(false);

  const handleOpen1 = (data, title) => {
    setCourseData(data);
    setCourseTitle(title);
    setOpen1(true);
  };

  const handleOpen2 = (data, title) => {
    setCourseData(data);
    setCourseTitle(title);
    setOpen2(true);
  };

  const handleOpen3 = (data, title) => {
    setCourseData(data);
    setCourseTitle(title);
    setOpen3(true);
  };

  const handleOpen4 = (data, title) => {
    setCourseData(data);
    setCourseTitle(title);
    setOpen4(true);
  };

  const handleClose1 = () => setOpen1(false);
  const handleClose2 = () => setOpen2(false);
  const handleClose3 = () => setOpen3(false);
  const handleClose4 = () => setOpen4(false);

  return (
    <div className="homePageContainer">

      {/* Welcome Section */}
      <div className="AEHSwelcomeSection">
        <Grid container>
          <Grid xs={12} md={5}>
            <div className="AEHSwelcomeContent">
              <div className='languageDropMobile row'>
                Select Language
                <div className="navbar-dropdown">
                  <select value={selectedLanguage} onChange={handleLanguageChange}>
                    <option value="en">English</option>
                    <option value="si">සිංහල</option>
                    <option value="tam">தமிழ்</option>
                  </select>
                </div>
              </div>
              <div className='screenOne'>
                <div className="AEHSwelcomeTitle topT1">{t.welcomeTitle}</div>
                <div className="welcomeSubtitle topT2">{t.welcomeSubtitle}<div className="welcomeSubtitle2"> {t.welcomeSubtitle2}</div></div>
                <div className="welcomeDescription topT3">
                  {t.welcomeDescription}
                </div>
              </div>
              <div className='screenTwo'>
                <div
                  className="aehsbutton applybtn"
                  onClick={() => window.open('https://forms.gle/s9rhYRDSZe1wuaN87', '_blank')}
                >
                  Apply Now
                </div>
                <div className="socialIcons">
                  <div><a href="https://www.facebook.com/www.asohca.lk" target="_blank" rel="noopener noreferrer" style={{ display: 'flex', flexDirection: 'row' }}><img src={facebookIcon} style={{ color: '#000', width: '20px' }} /></a></div>
                  <div className='instaIcon' onClick={() => window.open('https://www.instagram.com/asian_elite_hotel_school_/#', '_blank', 'noopener noreferrer')}>
                    <InstaIcon />
                  </div>
                </div>
              </div>
            </div>
          </Grid>
          <Grid xs={12} md={4} sx={{ display: { xs: 'none', sm: 'block' } }} className='heroImg'>
            <div className="AEHSwelcomeContent">
              <img src="https://str4edfdevwebapp.blob.core.windows.net/images/Chefs.png" />
            </div>
          </Grid>
          <Grid xs={12} md={3} className="calendarSection">
            <div className='languageDropWeb row'>
              Select Language
              <div className="navbar-dropdown">
                <select value={selectedLanguage} onChange={handleLanguageChange}>
                  <option value="en">English</option>
                  <option value="si">සිංහල</option>
                  <option value="tam">தமிழ்</option>
                </select>
              </div>
            </div>
            <div className="AEHSwelcomeContent">
              <div className="calendar"><Calender /></div>
              <div className="announcements"><AEHSAnnouncement /></div>
            </div>
          </Grid>
        </Grid>
      </div>

      {/* Course Categories */}
      <div className=''>
        <div className="AEHSwelcomeTitle d-flex justify-content-center">{t.Course_categories}</div>
        <div className="d-flex justify-content-center">
          <div className='row'>
            <div className="containerNVQ">
              <div className="nvqbox col-12 col-md-3 col-sm-6">
                <span></span>
                <div className="nvqcontent">
                  <h2>NVQ 3</h2>
                  <p>
                    International Cookery
                  </p>
                  <div>
                    <div className="courseCard" onClick={() => handleOpen1(nvq_3_international_cookery, { level: 'NVQ Level 03', course: 'International Cookery' })} style={{ cursor: 'pointer' }}>
                      Read More
                    </div>
                    <AehsCourseModal className='' open={open1} handleClose={handleClose1} courseData={courseData} courseTitle={courseTitle} />
                  </div>
                </div>
              </div>

              <div className="nvqbox col-12 col-md-3 col-sm-6">
                <span></span>
                <div className="nvqcontent">
                  <h2>NVQ 4</h2>
                  <p>
                    International Cookery
                  </p>
                  <div>
                    <div className="courseCard" onClick={() => handleOpen2(nvq_4_international_cookery, { level: 'NVQ Level 04', course: 'International Cookery' })} style={{ cursor: 'pointer' }}>
                      Read More
                    </div>
                    <AehsCourseModal open={open2} handleClose={handleClose2} courseData={courseData} courseTitle={courseTitle} />
                  </div>
                </div>
              </div>

              <div className="nvqbox col-12 col-md-3 col-sm-6">
                <span></span>
                <div className="nvqcontent">
                  <h2>NVQ 3</h2>
                  <p>
                    Bakery & Patisserie
                  </p>
                  <div>
                    <div className="courseCard" onClick={() => handleOpen3(nvq_3_bakery, { level: 'NVQ Level 03', course: 'Bakery & Patisserie' })} style={{ cursor: 'pointer' }}>
                      Read More
                    </div>
                    <AehsCourseModal open={open3} handleClose={handleClose3} courseData={courseData} courseTitle={courseTitle} />
                  </div>
                </div>
              </div>

              <div className="nvqbox col-12 col-md-3 col-sm-6">
                <span></span>
                <div className="nvqcontent">
                  <h2>NVQ 4</h2>
                  <p>
                    Bakery & Patisserie
                  </p>
                  <div>
                    <div className="courseCard" onClick={() => handleOpen4(nvq_4_bakery, { level: 'NVQ Level 04', course: 'Bakery & Patisserie' })} style={{ cursor: 'pointer' }}>
                      Read More
                    </div>
                    <AehsCourseModal open={open4} handleClose={handleClose4} courseData={courseData} courseTitle={courseTitle} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Photo Gallery */}
      <div className='subSection'>
        <div className="AEHSwelcomeTitle d-flex justify-content-center">Photo Gallery</div>
        <div className="welcomeDescription d-flex justify-content-center">
          See how our daily activities evolve
        </div>
        <div className='photoGallery'>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={4}>
              <img src={gallery1}
                className="galleryCard"
                alt="Gallery Image" />
            </Grid>
            <Grid item xs={12} sm={12} md={4}>
              <img src={gallery2}
                className="galleryCard"
                alt="Gallery Image" />
            </Grid>
            <Grid item xs={12} sm={12} md={4}>
              <img src={gallery3}
                className="galleryCard"
                alt="Gallery Image" />
            </Grid>
            <Grid item xs={12} sm={12} md={4}>
              <img src={gallery4}
                className="galleryCard"
                alt="Gallery Image" />
            </Grid>
            <Grid item xs={12} sm={12} md={4}>
              <img src={gallery5}
                className="galleryCard"
                alt="Gallery Image" />
            </Grid>
            <Grid item xs={12} sm={12} md={4}>
              <img src={gallery6}
                className="galleryCard"
                alt="Gallery Image" />
            </Grid>
            <Grid item xs={12} sm={12} md={4}>
              <img src={gallery7}
                className="galleryCard"
                alt="Gallery Image" />
            </Grid>
            <Grid item xs={12} sm={12} md={4}>
              <img src={gallery8}
                className="galleryCard"
                alt="Gallery Image" />
            </Grid>
            <Grid item xs={12} sm={12} md={4}>
              <img src={gallery9}
                className="galleryCard"
                alt="Gallery Image" />
            </Grid>
          </Grid>
        </div>
      </div>

      {/* Guidance Section */}
      <div className='subSection'>
        <div className="guidanceSection">
          <Grid container spacing={2}>
            <Grid item xs={12} md={8}>
              <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <div className='goodchef'>
                  <div className="AEHSwelcomeTitle">Anyone can be a chef with good guidance</div>
                  <div className="welcomeDescription">
                    UNLEASH YOUR CULINARY TALENT<br />
                    <br />
                    <div className='guidanceTxt'>
                      {t.guidance_text}
                    </div>
                  </div>
                  <div className="aehsbutton2 learnbtn" onClick={() => window.open(learnMore_pdf, '_blank', 'noopener noreferrer')}>
                    Learn More
                  </div>
                  {/* <img src={biscuits} style={{ width: '12vw' }} /> */}
                </div> </div>
            </Grid>

            <Grid item xs={12} md={4}>
              <CardMedia
                component="img"
                image="https://str4edfdevwebapp.blob.core.windows.net/images/guidance%201.png"
                alt="Guidance Image"
                className="guidanceImage"
              />
            </Grid>
          </Grid>
        </div>
      </div>

      {/* FAQ Section */}
      <div className='subSection'>
        <div className='AEHSfaq'>
          <div className="AEHSwelcomeTitle d-flex justify-content-center">FAQ</div>
          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography>Where is this hotel school located?</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <div className='AehsAnswers'>
                It’s at No. 55B, Ananda Coomaraswamy Mawatha, Colombo 3 (opposite Cargills).
              </div>
            </AccordionDetails>
          </Accordion>

          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography>What is the course duration?</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <div className='AehsAnswers'>
                NVQ3 - 30 days from 9 am – 3 pm from the day you join.
              </div>
            </AccordionDetails>
          </Accordion>

          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography>When is the next class starting?</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <div className='AehsAnswers'>
                Classes are held daily.  You can join today and complete the syllabus within the allocated duration.
              </div>
            </AccordionDetails>
          </Accordion>

          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography>Are there weekend courses?</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <div className='AehsAnswers'>
                Yes.   On Sundays only.  If you need to expedite completion, you may attend week day classes, too according to your availability.
              </div>
            </AccordionDetails>
          </Accordion>

          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography>Do you have NVQ4 courses?  What is the duration and other details?</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <div className='AehsAnswers'>
                Yes.   NVQ4 - 3 days per week.  6 months training at Asian Elite Hotel School and 6 months industrial training in a hotel.
              </div>
            </AccordionDetails>
          </Accordion>

          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography>What is the certificate issued?  Is it globally recognized?</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <div className='AehsAnswers'>
                NVQ3 and NVQ4 Certificates.  They are issued by TVEC (Tertiary & Vocational Educational Commission) after successful completion of Assessments by them held only at Asian Elite Hotel School.
                <br />
                Yes.  Both certificates are globally recognised highly valuable certificates.
              </div>
            </AccordionDetails>
          </Accordion>
        </div>
      </div>

      {/* Social Media Section */}
      <div className='subSection'>
        <div className='AEHSSocialMedia'>
          <div className="AEHSwelcomeTitle">Check out @Asian Elite Hotel School on social media</div>
          <div class="container">
            <div class="row" style={{ display: 'flex', justifyContent: 'center' }}>
              <div className='col-lg-3 col-md-4 col-sm-12 xs-12 mb-4'>
              </div>
              <div className='col-lg-3 col-md-4 col-sm-12 xs-12 mb-4'>
                <img src={instaimg}
                  className="smImage"
                  alt="Gallery Image" />
                <div
                  className="aehsbutton2"
                  onClick={() => window.open('https://www.instagram.com/asian_elite_hotel_school_/#', '_blank', 'noopener,noreferrer')}
                  style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}
                >
                  Visit Our Instagram &emsp;
                  <InstaIcon />
                </div>
              </div>
              <div className='col-lg-3 col-md-4 col-sm-12 xs-12 mb-4'>
                <img src={fbimg}
                  className="smImage"
                  alt="Gallery Image" />
                <div
                  className="aehsbutton2"
                  onClick={() => window.open('https://www.facebook.com/www.asohca.lk', '_blank', 'noopener,noreferrer')}
                  style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}
                >
                  Visit Our Facebook &emsp;
                  <img src={facebookWhiteIcon} style={{ color: '#fff', width: '20px' }} />
                </div>
              </div>
              <div className='col-lg-3 col-md-4 col-sm-4 xs-12 mb-4'>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/*Testiminial*/}
      {/* <div>
        <div className="AEHSwelcomeTitle">Testimonial</div>
      </div> */}

    </div>
  );
};

export default HomePage;
